import React from "react";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauthExternal } from "./interceptor";
import { ApiResponse } from "model/response-model";

export const externalApi = createApi({
  reducerPath: "externalApi",
  baseQuery: baseQueryWithReauthExternal,
  endpoints: (builder) => ({
    deleteCompany: builder.mutation<ApiResponse<any>, string>({
      query: (subdomain) => ({
        url: `${
          process.env.REACT_APP_DOMAIN_BASE || "https://api.pactocoin.com"
        }/api/tenant/deletetenant/${subdomain}`,
        method: "DELETE",
        headers: { subdomain: subdomain },
      }),
    }),
  }),
});

export const { useDeleteCompanyMutation } = externalApi;

// export const externalApi = createApi({
//   reducerPath: 'externalApi',
//   baseQuery: baseQueryWithReauthExternal,
//   endpoints: (builder) => ({
//     deleteCompany: builder.mutation<ApiResponse<any>, { subdomain: string }>({
//       query: ({ subdomain }) => ({
//         url: `/api/tenant/deletetenant/${subdomain}`,
//         method: 'DELETE',
//         // No need to set headers here; interceptor handles it
//       }),
//     }),
//   }),
// });

// export const { useDeleteCompanyMutation } = externalApi;
